// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setActiveSessionsData: (state: IRootState, action: PayloadAction<IRootState['active_sessions']>) => ({
    ...state,
    active_sessions: action.payload,
  }),
  resetActiveSessionsData: () => initialState,
};

export { reducers };
